__turbopack_context__.v({
  "list": "BasicList-module-scss-module__0MAiiW__list",
  "text": "BasicList-module-scss-module__0MAiiW__text",
});
